import { Typography, Grid , Box, TextField,MenuItem} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { handleAxiosError } from '../../../config/action-config';
import { useDispatch, useSelector } from 'react-redux';
import { getEmpPaySlipDefault, getPayslipEmpList } from '../../../api/payslipApis';

export default function PayslipEmployeeDetail({handleInputChange,formData}) {
  const [employeeList, setempList] = useState([]);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const[empId,setEmpId]=useState();
  const[empData,setEmpData]=useState()

  useEffect(() => {
    getEmployeeListDetail();
  
  }, []);

  async function getEmployeeListDetail() {
    try {
      const { data } = await getPayslipEmpList(
        { limit: "", offset: "" },
        user.token
      );
      //  console.log(data,"data")
      setempList([...data.data.data]);
      setEmpId(data?.data?.data[0]?.id);
      // console.log(data?.data?.data[0]?.id,"empid");
    } catch (error) {
      // console.log("eroor2");
      handleAxiosError(error, dispatch);
    }
  }
 
console.log(formData.employee,"formData.employeeer");
  return (
    <Grid container spacing={2} style={{marginBottom: "30px"}} >
         <Grid item xs={12} md={6} sm={6} sx={{m:"10px"}}>
    <Box className="typography-title">
    <Typography variant="h1" className="payslip-heading-h1">
    Employee
    </Typography>
    </Box>
    </Grid>
    <Grid container spacing={3} className=""sx={{display:"flex",justifyContent:"center",m:2,mb:2}}>

              <Grid item xs={10} md={5} sm={5}>
                <TextField
                  name="employee_code"
                  fullWidth
                  label="Employee Code"
                  onChange={handleInputChange}
                  value={formData.employee_code}
                  type="text"
                  color="secondary"
                  required
                //   value={open?.data?.emp_name}
                
                />
              </Grid>
              <Grid item xs={10} md={5} sm={5}>
                <TextField
                  name="pay_date"
                  fullWidth
                  label="Pay Date"   
                  value={formData.pay_date}          
                onChange={handleInputChange}

                  required
                  type="date"
                />
              </Grid>
              <Grid item xs={10} md={5} sm={5}>
                <TextField
                  fullWidth
                  name="employee"
                  label="Employee Name"
                  type="text"
                  value={formData.employee}
                  onChange={handleInputChange}
                  select
                  required
                > 
                {employeeList?.map((el, i) => {
                  // console.log(el,"cjs")
                  return (
                    <MenuItem key={i} value={el.id}>
                      {el.employee_name}
                    </MenuItem>
                  );
                })}
                </TextField>
              </Grid>
              <Grid item xs={10} md={5} sm={5}>
                <TextField
                  name="pay_period"
                  fullWidth
                  label="Pay Period "
                  value={formData.pay_period}
                  onChange={handleInputChange}
                  type="text"
                  required
                //   value={open?.data?.emp_name}
                
                />
              </Grid>
              <Grid item xs={10} md={5} sm={5}>
                <TextField
                  name="father_name"
                  fullWidth
                  label="Father's Name"
                  value={formData.father_name}
                  onChange={handleInputChange}
                  type="text"
                  required
                //   value={open?.data?.emp_name}
                
                />
              </Grid>

              <Grid item xs={10} md={5} sm={5}>
                <TextField
                  name="bank_name"
                  fullWidth
                  label="Bank Name"
                  value={formData.bank_name}
                  onChange={handleInputChange}
                  type="text"
                  required
                //   value={open?.data?.emp_name}
                
                />
                
              </Grid>
              <Grid item xs={10} md={5} sm={5}>
                <TextField
                  name="designation"
                  fullWidth
                  label="Designation"
                  value={formData.designation}
                  onChange={handleInputChange}
                  type="text"
                  required
                //   value={open?.data?.emp_name}
                
                />
                
              </Grid>
              <Grid item xs={10} md={5} sm={5}>
                <TextField
                  name="account_number"
                  fullWidth
                  label="Account Number"
                  value={formData.account_number}
                  onChange={handleInputChange}
                  type="number"
                  required
                //   value={open?.data?.emp_name}
                
                />
                
              </Grid>
              <Grid item xs={10} md={5} sm={5}>
                <TextField
                  name="department"
                  fullWidth
                  onChange={handleInputChange}
                  label="Department"
                  value={formData.department}
                  type="text"
                  required
                //   value={open?.data?.emp_name}
                
                />
                
              </Grid>
              <Grid item xs={10} md={5} sm={5}>
                <TextField
                  name="ifsc_code"
                  fullWidth
                  onChange={handleInputChange}
                  value={formData.ifsc_code}
                  label="IFSC Code"
                  type="text"
                  required
                //   value={open?.data?.emp_name}
                
                />
                
              </Grid>
              <Grid item xs={10} md={5} sm={5}>
                <TextField
                  name="pan_number"
                  fullWidth
                  onChange={handleInputChange}
                  label="PAN Number"
                  value={formData.pan_number}
                  type="text"
                  required
                //   value={open?.data?.emp_name}
                
                />
                
              </Grid>
              <Grid item xs={10} md={5} sm={5}>
                <TextField
                  name="payment_mode"
                  fullWidth
                  onChange={handleInputChange}
                  value={formData.payment_mode}
                  label="Payment Mode"
                  type="text"
                  required
                //   value={open?.data?.emp_name}
                
                />
                
              </Grid>
              <Grid item xs={10} md={5} sm={5}>
                <TextField
                  name="joining_date"
                  fullWidth
                  onChange={handleInputChange}
                  value={formData.joining_date}
                  label="Joining Date"
                  type="date"
                  required
                //   value={formatDateToYYYYMMDD(open?.data?.emp_name)}
                
                />
                
              </Grid>
              <Grid item xs={10} md={5} sm={5}>
                <TextField
                  name="uan_number"
                  fullWidth
                  onChange={handleInputChange}
                  value={formData.uan_number}
                  label="UAN Number"
                  type="number"
                  required
                //   value={open?.data?.emp_name}
                
                />
                
              </Grid>
              <Grid item xs={10} md={5} sm={5}>
                <TextField
                  name="work_location"
                  fullWidth
                  onChange={handleInputChange}
                  value={formData.work_location}
                  label="Work Location"
                  type="text"
                  required
                //   value={open?.data?.emp_name}
                
                />
                
              </Grid>
              <Grid item xs={10} md={5} sm={5}>
                <TextField
                  name="effective_days"
                  fullWidth
                  onChange={handleInputChange}
                  value={formData.effective_days}
                  label="Effective Days"
                  type="number"
                  required
                //   value={open?.data?.emp_name}
                
                />
                
              </Grid>
</Grid>
</Grid>
  )
}
function formatDateToYYYYMMDD(isoDateString) {
  if (!isoDateString) return ""; // Return empty string if input is falsy

  const datePortion = isoDateString.split("T")[0];
  return datePortion;
}

